module.exports = __webpack_public_path__ + "img/logo.59a8068f.png";